module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": "",
      "lg9": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "ml-2 mt-2 font-14 fw-400 primary--text",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('userRanking.avatar')) + "\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "lg3": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('userRanking.nickname')) + "\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    IOB Power\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    IOB Tokens\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    RS\n                                ")])], 1), _vm._v(" "), _vm._l((_vm.userInfoList), function(user, index) {
    return [_c('v-divider'), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-2 font-14 fw-400 pointer",
      attrs: {
        "row": "",
        "align-center": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoUserData(user.userName)
        }
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": "primary pointer",
        "size": "36"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "font-24 white--text"
    }, [_vm._v("\n                                                " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "lg3": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(user.nickName) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("NumFormat")(user.iobPower.toFixed(2))) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("NumFormat")(user.iobTokens.toFixed(2))) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(user.reputationScore) + "\n                                    ")])], 1), _vm._v(" "), _c('v-divider', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    })]
  })], 2), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mt-5 mb-5 fw-400",
    attrs: {
      "identifier": _vm.infiniteId
    },
    on: {
      "infinite": _vm.getUserRanking
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4561a8e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserRanking.vue
// module id = 434
// module chunks = 0